var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.69844 7.36688L14.001 2.06489C14.6184 1.83432 15.1576 2.22059 14.9576 3.18567L12.6937 14.2151C12.5259 14.9972 12.0763 15.1874 11.4474 14.8189L7.99818 12.1911L6.3345 13.8479C6.15054 14.0381 5.99532 14.1985 5.6389 14.1985L5.8838 10.57L12.2764 4.60001C12.5546 4.34685 12.2143 4.20423 11.8475 4.4562L3.94762 9.59774L0.542075 8.49955C-0.197212 8.25709 -0.213308 7.73533 0.69844 7.36688Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.f77a8740d6098502de318eb95eef7415.svg";
export { ForwardRef as ReactComponent };